import React, { useState, useEffect } from 'react';
import { Box, Button , Grid2, TextField, Typography } from '@mui/material';
import CustomTable from '../../components/table/Table';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTemplates, updateTemplate,deleteTemplate } from '../../redux/Slice/showcase/templateSlice';
import { toast } from 'sonner';
import ConfirmDialog from '../../components/dialog/dialog'; 
import { clearMessage } from "../../redux/Slice/message"
import { setLoading } from "../../redux/Slice/loaderSlice"
import { useNavigate } from "react-router-dom";
import TemplateCard from '../../components/card/TemplateCard';

const columns = [
  { id: "sno", label: "S.No", minWidth: 100, align: "start" },
  { id: 'service', label: 'Service', minWidth: 150, align: 'start' },
  { id: 'template', label: 'Template', minWidth: 150, align: 'start' },
  { id: 'name', label: 'Name', minWidth: 150, align: 'start' },
  // { id: 'status', label: 'Status', minWidth: 100, align: 'center' },
  { id: 'action', label: 'Action', minWidth: 150, align: 'center', actionType: [{ view: true, edit: true }] },
];

export const Alltemplate = () => {

  const navigate = useNavigate();
  
  const dispatch = useDispatch();
  const { templates, totalCount } = useSelector((state) => state.template);
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDialog, setOpenDialog] = useState(false); 
  const [selectedTemplate, setSelectedTemplate] = useState(null); 

  const message = useSelector((state) => state.message)

  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])


  const modifiedRows = templates? templates?.map((va, index)=> ({sno:(index+1+((page-1)*rowsPerPage)), service: va?.service_id?.name, template:va?.template_id?.templateName, ...va})) : [] ;


  useEffect(() => {

    const params = {
      page: page,
      limit: rowsPerPage,
      searchQuery
    }
    dispatch(fetchTemplates(params));
  }, [dispatch,page, rowsPerPage,searchQuery]);

  const handleStatusToggle = (template) => {
    setSelectedTemplate(template);
    setOpenDialog(true); 
  };

  const handleConfirmStatus = async() => {
    dispatch(setLoading(true))   

    if (selectedTemplate) {
      
      const updatedStatus = !selectedTemplate.status;
      // console.log("Updated Status:",updatedStatus);
      
      await dispatch(updateTemplate({ id: selectedTemplate._id, formData: {...selectedTemplate, status: updatedStatus } }))
        .then(() => {
          dispatch(fetchTemplates());
        })
        .catch((error) => {
          dispatch(setLoading(false))   
        })
        .finally(() => {
          dispatch(setLoading(false))   

          setOpenDialog(false); 
        });
    }
  };


  const handleEdit = (template) => {
    navigate(`/show/editor/${template._id}`, { state: { name: "edit" } });
  };
  
  

  

  const handleView=(template)=>{
    navigate(`/show/template/${template._id}`
      
    );


  }

 const onDelete=async(template)=>{
  dispatch(setLoading(true))   

 await dispatch(deleteTemplate(template._id))
 .then(() => {
  dispatch(fetchTemplates());
})
.catch((error) => {
  dispatch(setLoading(false))   
})
.finally(() => {
  dispatch(setLoading(false))
})
 

 }

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedTemplate(null); 
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value)
    setPage(1); // Reset to first page on search
};

  return (
    <div className="content">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
          Template List <Typography component="span">({templates.length})</Typography>
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
 <TextField placeholder="Search by Template Name"  onChange={handleSearch}
 fullWidth />          
 <Button variant="contained" color="success" onClick={() => navigate("/show/editor")} sx={{ml:2}}>add</Button>

        </Box>
      </Box>

      <CustomTable
        columns={columns}
        rows={templates ? modifiedRows : []}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        handleEdit={handleEdit}
        handleView={handleView}
        handleStatus={handleStatusToggle} 
        totalCount={totalCount}
      />

      {/* <Grid2 container spacing={2}>
        {templates && templates.map((template)=>(
           <Grid2 item size={{xs:12, sm:6, md:3}} key={template.id}>
            <TemplateCard
            template={template}
            onEdit={handleEdit}
            onView={handleView}
            onStatusToggle={handleStatusToggle} 
            onDelete={onDelete}
            />
          </Grid2>
        ))}
      </Grid2> */}

      <ConfirmDialog
        open={openDialog}
        message={`Are you sure you want to mark this template as ${selectedTemplate?.status ? 'inactive' : 'active'}?`}
        onClose={handleDialogClose}
        onConfirm={handleConfirmStatus}
      />
    </div>
  );
};
